module.exports = __webpack_public_path__ + "media/images/common/ico-checked-7807b01749c630398f07faefe501f7a7.svg";